// The admin Disputes table: the merchant list one level up. Every column the merchant
// table already defines is reused from its field defs; this file only names which columns
// the admin table offers, in which order, and which of them the backend can sort on.
import { COLUMN_ICONS, SORTABLE } from "../../DisputesPage/pages/AllPage/constants/allPageData"

// Columns in their default order: the account block right after Status, then the dispute
// itself, with our success fee last. `#` and Status stay frozen at the left (see
// buildAdminColumns); everything here is toggleable through Edit columns.
export const ADMIN_DISPUTE_COLUMNS = [
  { field_id: "number", label: "#", active: true },
  { field_id: "status", label: "Status", active: true },
  { field_id: "user_full_name", label: "User full name", active: true },
  { field_id: "user_email", label: "User email", active: true },
  { field_id: "business_account", label: "Business account", active: true },
  { field_id: "business_website", label: "Business URL", active: true },
  { field_id: "dispute_type", label: "Type", active: true },
  { field_id: "customer_full_name", label: "Customer full name", active: true },
  { field_id: "amount", label: "Amount", active: true },
  { field_id: "reason_code", label: "Reason code", active: true },
  { field_id: "issuer", label: "Card network", active: true },
  { field_id: "dispute_created_at", label: "Dispute date", active: true },
  { field_id: "due_by", label: "Due", active: true },
  { field_id: "paid_status", label: "Paid status", active: true },
  { field_id: "paid_amount", label: "Paid amount", active: true },
  { field_id: "issuing_bank", label: "Issuer", active: false },
  { field_id: "card_type", label: "Card type", active: false },
  { field_id: "country", label: "Country", active: false },
  { field_id: "processor", label: "Payment processor", active: false },
  { field_id: "flag_reason", label: "Flag", active: false },
  { field_id: "updated_at", label: "Last update", active: false }
]

// Chips on screen before anyone touches anything, mirroring the Alerts panel's admin
// defaults: status, the account owner's email, the account, and a date range.
export const ADMIN_DEFAULT_VISIBLE_FILTERS = {
  status: true,
  user_email: true,
  business_account: true,
  date: true
}

// Everything the "+ Add filter" dropdown may offer. `<Filters>` renders a row only when
// `ADMIN_FILTER_TYPES` also knows the key, so this is the display order.
export const ADMIN_FILTER_FIELDS = [
  { field_id: "user_full_name", label: "User full name" },
  { field_id: "user_email", label: "User email" },
  { field_id: "business_account", label: "Business account" },
  { field_id: "business_url", label: "Business URL" },
  { field_id: "paid_status", label: "Paid status" },
  { field_id: "status", label: "Status" },
  { field_id: "dispute_type", label: "Type" },
  { field_id: "flag_reason", label: "Flag" },
  { field_id: "submission", label: "Submission" },
  { field_id: "reason_category", label: "Category" },
  { field_id: "reason_code", label: "Reason code" },
  { field_id: "issuer", label: "Card network" },
  { field_id: "issuing_bank", label: "Issuer" },
  { field_id: "customer", label: "Customer full name" },
  { field_id: "assignee", label: "Assignee" },
  { field_id: "amount", label: "Amount" },
  { field_id: "enrichment", label: "Enrichment" },
  { field_id: "date", label: "Dispute date" },
  { field_id: "updated", label: "Last update" },
  { field_id: "card_type", label: "Card type" },
  { field_id: "currency", label: "Currency" },
  { field_id: "card_country", label: "Country" },
  { field_id: "processor", label: "Payment processor" },
  { field_id: "card_last4", label: "Card last 4" },
  { field_id: "processor_dispute_id", label: "Dispute ID" }
]

// The merchant list's sortable set plus the columns only this table has.
export const ADMIN_SORTABLE = new Set([
  ...SORTABLE,
  "user_full_name",
  "user_email",
  "business_account",
  "paid_status",
  "paid_amount"
])

export const ADMIN_COLUMN_ICONS = {
  ...COLUMN_ICONS,
  user_full_name: "user",
  user_email: "email",
  business_account: "two_users",
  business_website: "globus",
  business_url: "globus",
  paid_status: "pulse",
  paid_amount: "money",
  dispute_type: "type"
}

export const ADMIN_PAGE_SIZE = 50
